function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "startWithTem",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.000000, 12.000000)",
  fill: "#7F7E7E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37,0 L37,26 L0,26 L0,0 L37,0 Z M35,2 L2,2 L2,24 L35,24 L35,2 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,3.5 C17.7614237,3.5 20,5.73857625 20,8.5 C20,11.2614237 17.7614237,13.5 15,13.5 C12.2385763,13.5 10,11.2614237 10,8.5 C10,5.73857625 12.2385763,3.5 15,3.5 Z M15,5.5 C13.3431458,5.5 12,6.84314575 12,8.5 C12,10.1568542 13.3431458,11.5 15,11.5 C16.6568542,11.5 18,10.1568542 18,8.5 C18,6.84314575 16.6568542,5.5 15,5.5 Z",
  id: "Oval"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "15.229 19.347 25.5026589 7.02406022 37.0974739 20.674832 35.5731357 21.969588 25.516 10.13 15.3297885 22.3501441 8.249 14.927 1.543422 21.5596516 0.137064511 20.1376254 8.29159279 12.0729486"
})));

function SvgStartWithTem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "startWithTem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWithTem);
export default __webpack_public_path__ + "static/media/startWithTem.43ba665a.svg";
export { ForwardRef as ReactComponent };